(ns ycweb.app.blitz.cardlinking.cardlinking
  (:require
   [rum.core :as rum]
   [ycweb.components.forms :as forms]
   [ycweb.util.core :as u]
   [ycweb.components.grid :as grid]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.wrapper :as w]
   [ycweb.components.transitions :as t]
   [ycweb.components.toaster :as toaster]
   [ycweb.util.sound :as sound]
   [ycweb.util.comms :as comms]
   [util.string :as str]))

(def steps
  (forms/setup-steps
    [{:key :card-scan :title "Scan Card"}
     {:key :shelf-scan :title "Scan Shelf"}]))

(defn format-card-data
  [{:keys [noorder lastactivity site refid receivername queuestack packlanes
           unpicking readypicking topqueued currentwarehousepo] :as card}]
  (let [subtext (str site refid " - " receivername)]
    (cond
      lastactivity
      {:success true
       :main
       (if (= "Cancelled" (:type lastactivity))
         "Cancelled card"
         "Stale card")
       :sub (:msg lastactivity)
       :tts (str "Stale card, " (:msg lastactivity))}

      (or noorder (nil? card))
      {:stacktype "Stale"
       :main "Stale card"
       :sub "Possible problem"
       :tts "Stale card"}

      (not currentwarehousepo)
      {:stacktype "Other Warehouse"
       :main "Other Warehouse"
       :sub "Take card to other warehouse"
       :tts "Take card to other warehouse"}

      (u/presence packlanes)
      (let [packlane (first (str/split packlanes #","))]
        {:stacktype "Ready"
         :main packlane
         :sub subtext
         :packlane packlane
         :tts packlane})

      (pos? unpicking)
      {:stacktype "Unpicking"
       :main "Unpicking"
       :sub subtext
       :tts "Unpicking"}

      (and (not readypicking) topqueued)
      {:stacktype "Top of queue"
       :main "Top of queue"
       :sub subtext
       :tts "Top of queue"}

      (not readypicking)
      (let [maintext
            (if (pos? queuestack)
              (str "Queue " queuestack)
              "Queued")]
        {:stacktype "Queued"
         :main maintext
         :sub subtext
         :tts maintext})

      :else
      {:stacktype "Picking"
       :main "Not picked yet"
       :sub subtext
       :tts "Not picked yet"})))

(defmethod comms/receive :cardlinking/shelf-scan [app-atom {:keys [msg]}]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom update :cardlinking dissoc :carddata)
  (t/transition-next app-atom :cardlinking/card-scan)
  (sound/tts msg)
  (toaster/open-toast app-atom :success msg {}))

(defmethod grid/action :cardlinking/shelf-scan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (let [cardcode (get-in @app-atom [:cardlinking :carddata :cardcode])]
    (comms/send :cardlinking/shelf-scan {:scan scan :cardcode cardcode})))

(defmethod flow/barcode-dispatch-screen :cardlinking/shelf-scan [_ app-atom scan]
  (cond
    (= scan (get-in @app-atom [:cardlinking :carddata :packlane]))
    (grid/dispatch-action app-atom :cardlinking/shelf-scan {:scan scan})

    :else
    (grid/dispatch-action app-atom :cardlinking/card-scan {:scan scan})))

(defn menu-modal [app-atom]
  (grid/menu-modal app-atom
    {:items
     [{:label "Refresh Cache"
       :action :cardlinking/refresh-cache}

      {:label "Cancel"
       :action :cardlinking/menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(rum/defc shelf-scan < rum/reactive [app-atom]
  (let [{:keys [carddata cache-date]} (cmn/curact app-atom [:cardlinking])
        {:keys [maintext cardcode subtext]} carddata]
    (w/wrapper app-atom "Card Linking" {:modal-fn menu-modal :steps steps :step :shelf-scan}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         (str cardcode " - " maintext)
         [:span.heading__subtext subtext]]
        grid/barcode-icon]]
      [[:aside.page-body__footer
        [:p.u-text-center
         {:class (u/bem :paragraph [:flush])}
         (str "Cache: " cache-date)]]]
      (grid/pos-call-to-action
        {:left-fn #(grid/dispatch-action app-atom :cardlinking/refresh-cache {})
         :right-text "Scan Shelf"
         :right-plain true}))))

(defmethod flow/render-screen :cardlinking/shelf-scan [app-atom _]
  (shelf-scan app-atom))

(defmethod comms/receive :cardlinking/card-scan [app-atom {:keys [carddata cardcode]}]
  (toaster/close-subtle-progress app-atom)
  (let [card (format-card-data carddata)]
    (sound/tts (:tts card))
    (swap! app-atom update-in [:cardlinking :carddata] assoc
      :maintext (:main card)
      :packlane (:packlane card)
      :cardcode cardcode
      :subtext (:sub card))
    (cond
      (:packlane card)
      (t/transition-next app-atom :cardlinking/shelf-scan)

      :else
      (t/transition-next app-atom :cardlinking/card-scan))))

(defmethod grid/action :cardlinking/card-scan [app-atom {:keys [scan]} _]
  (let [card-cache (get-in @app-atom [:cardlinking :cache scan])
        card (format-card-data card-cache)]
    (cond
      card-cache
      (do
        (comms/send :cardlinking/logactivity
          {:scan scan
           :stacktype (:stacktype card)
           :stack (:queuestack card-cache)})
        (sound/tts (:tts card))
        (swap! app-atom update-in [:cardlinking :carddata] assoc
          :subtext (:sub card)
          :cardcode scan
          :packlane (:packlane card)
          :maintext (:main card))
        (cond
          (:packlane card)
          (t/transition-next app-atom :cardlinking/shelf-scan)

          :else
          (t/transition-next app-atom :cardlinking/card-scan)))

      :else
      (do
        (toaster/open-subtle-progress app-atom)
        (comms/send :cardlinking/card-scan {:scan scan})))))

(defmethod flow/barcode-dispatch-screen :cardlinking/card-scan [_ app-atom scan]
  (grid/dispatch-action app-atom :cardlinking/card-scan {:scan scan}))

(rum/defc card-scan < rum/reactive [app-atom]
  (let [{:keys [carddata cache-date]} (cmn/curact app-atom [:cardlinking])
        {:keys [maintext cardcode subtext]} carddata]
    (w/wrapper app-atom "Card Linking" {:modal-fn menu-modal :steps steps :step :card-scan}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         (if cardcode
           (str cardcode " - " maintext)
           "Scan Card")
         [:span.heading__subtext
          subtext]]
        grid/barcode-icon]]
      [[:aside.page-body__footer
        [:p.u-text-center
         {:class (u/bem :paragraph [:flush])}
         (str "Cache: " cache-date)]]]
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom :main-menu)
         :right-text "Scan Card"
         :right-plain true}))))

(defmethod flow/render-screen :cardlinking/card-scan [app-atom _]
  (card-scan app-atom))

(defmethod comms/receive :cardlinking/refresh-cache [app-atom {:keys [cache cache-date]}]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom update :cardlinking assoc
    :carddata nil
    :cache cache
    :cache-date cache-date)
  (t/transition-next app-atom :cardlinking/card-scan))

(defmethod grid/action :cardlinking/refresh-cache [app-atom _ _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :cardlinking/refresh-cache {}))
